import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { BookOpen, LogIn, LogOut } from 'lucide-react';

export default function Navbar() {
  const { user, isAuthenticated, logout } = useAuthStore();

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 text-xl font-bold text-blue-600">
              <BookOpen size={28} />
              <span>LMS</span>
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/courses" className="text-gray-600 hover:text-blue-600 transition">คอร์สทั้งหมด</Link>
              {isAuthenticated && (
                <Link to="/dashboard" className="text-gray-600 hover:text-blue-600 transition">แดชบอร์ด</Link>
              )}
            </div>
          </div>
          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <>
                <span className="text-sm text-gray-600">{user?.firstName}</span>
                <button onClick={logout} className="flex items-center gap-1 text-red-500 hover:text-red-700 transition">
                  <LogOut size={18} />
                  ออกจากระบบ
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="flex items-center gap-1 text-gray-600 hover:text-blue-600 transition">
                  <LogIn size={18} />
                  เข้าสู่ระบบ
                </Link>
                <Link to="/register" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition">
                  สมัครสมาชิก
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
